document.addEventListener("DOMContentLoaded", function () {
  const stickyBar = document.getElementById("StickyAddToCart");
  if (!stickyBar) return;

  const buyButtons = document.querySelector(".product-form__buttons");
  const footer = document.querySelector("footer");
  let isVisible = false;
  let isFooterVisible = false;
  let isBuyButtonsVisible = false;
  let isAboveBuyButtons = true;
  const DESKTOP_WIDTH = 750;

  // Function to sync variant selection
  function syncVariantSelection(
    sourceElement,
    targetElements,
    isRadio = false,
  ) {
    const value = sourceElement.value;
    const optionIndex = sourceElement.dataset.optionIndex;
    const optionName = sourceElement.name;

    targetElements.forEach((element) => {
      if (isRadio) {
        if (element.value === value && element.name === optionName) {
          element.checked = true;
          // Use a custom event to avoid form submission
          element.dispatchEvent(new CustomEvent("change", { bubbles: true }));
        }
      } else {
        if (
          element.dataset.optionIndex === optionIndex ||
          element.name === optionName
        ) {
          element.value = value;
          // Use a custom event to avoid form submission
          element.dispatchEvent(new CustomEvent("change", { bubbles: true }));
        }
      }
    });
  }

  // Get all variant selection elements
  const mainFormSelects = document.querySelectorAll("variant-selects select");
  const mainFormRadios = document.querySelectorAll(
    'variant-radios input[type="radio"]',
  );
  const stickySelects = document.querySelectorAll(".sticky-add-to-cart select");

  // Prevent form submission on select changes
  stickySelects.forEach((select) => {
    select.addEventListener("change", (e) => {
      e.preventDefault();
      e.stopPropagation();
    });
  });

  // Sync from main form selects to sticky bar and radios
  mainFormSelects.forEach((select) => {
    select.addEventListener("change", (e) => {
      // Prevent default only for programmatic changes
      if (!e.isTrusted) {
        e.preventDefault();
        e.stopPropagation();
      }
      // Sync with sticky selects
      syncVariantSelection(select, stickySelects);

      // Sync with radio buttons
      const optionName = select.name.replace("options[", "").replace("]", "");
      const matchingRadios = Array.from(mainFormRadios).filter(
        (radio) => radio.name === optionName,
      );
      syncVariantSelection(select, matchingRadios, true);
    });
  });

  // Sync from main form radios to sticky bar and selects
  mainFormRadios.forEach((radio) => {
    radio.addEventListener("change", (e) => {
      // Prevent default only for programmatic changes
      if (!e.isTrusted) {
        e.preventDefault();
        e.stopPropagation();
      }
      if (radio.checked) {
        const optionName = radio.name;
        // Find corresponding sticky select by option name
        const stickySelect = Array.from(stickySelects).find((select) => {
          const selectName = select.name
            .replace("options[", "")
            .replace("]", "");
          return selectName === optionName;
        });

        if (stickySelect) {
          stickySelect.value = radio.value;
          stickySelect.dispatchEvent(
            new CustomEvent("change", { bubbles: true }),
          );
        }

        // Sync with main form selects
        const mainFormSelect = Array.from(mainFormSelects).find((select) => {
          const selectName = select.name
            .replace("options[", "")
            .replace("]", "");
          return selectName === optionName;
        });

        if (mainFormSelect) {
          mainFormSelect.value = radio.value;
          mainFormSelect.dispatchEvent(
            new CustomEvent("change", { bubbles: true }),
          );
        }
      }
    });
  });

  // Sync from sticky bar to main form selects and radios
  stickySelects.forEach((select) => {
    select.addEventListener("change", (e) => {
      // Get the option name without the "options[]" wrapper
      const optionName = select.name.replace("options[", "").replace("]", "");

      // Find and update main form select
      const mainFormSelect = Array.from(mainFormSelects).find((mainSelect) => {
        const mainSelectName = mainSelect.name
          .replace("options[", "")
          .replace("]", "");
        return mainSelectName === optionName;
      });

      if (mainFormSelect) {
        mainFormSelect.value = select.value;
        mainFormSelect.dispatchEvent(
          new CustomEvent("change", { bubbles: true }),
        );
      }

      // Find and update radio button
      const mainFormRadio = Array.from(mainFormRadios).find(
        (radio) => radio.name === optionName && radio.value === select.value,
      );

      if (mainFormRadio) {
        mainFormRadio.checked = true;
        mainFormRadio.dispatchEvent(
          new CustomEvent("change", { bubbles: true }),
        );
      }
    });
  });

  // Function to update sticky bar visibility
  function updateStickyBarVisibility() {
    const isDesktop = window.innerWidth > DESKTOP_WIDTH;

    if (isDesktop) {
      // On desktop, only show when scrolled past the buy buttons and they're not visible
      if (!isBuyButtonsVisible && !isFooterVisible && !isAboveBuyButtons && !isVisible) {
        stickyBar.classList.add("visible");
        isVisible = true;
      } else if ((isBuyButtonsVisible || isFooterVisible || isAboveBuyButtons) && isVisible) {
        stickyBar.classList.remove("visible");
        isVisible = false;
      }
    } else {
      // On mobile, show whenever buy buttons are not visible (original behavior)
      if (!isBuyButtonsVisible && !isFooterVisible && !isVisible) {
        stickyBar.classList.add("visible");
        isVisible = true;
      } else if ((isBuyButtonsVisible || isFooterVisible) && isVisible) {
        stickyBar.classList.remove("visible");
        isVisible = false;
      }
    }
  }

  // Check if we're above the buy buttons
  function updateScrollPosition() {
    if (buyButtons) {
      const buyButtonsRect = buyButtons.getBoundingClientRect();
      isAboveBuyButtons = buyButtonsRect.top > window.innerHeight;
      updateStickyBarVisibility();
    }
  }

  // Show/hide sticky bar based on visibility
  const buyButtonsObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        isBuyButtonsVisible = entry.isIntersecting;
        updateStickyBarVisibility();
      });
    },
    { threshold: 0 }
  );

  const footerObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        isFooterVisible = entry.isIntersecting;
        updateStickyBarVisibility();
      });
    },
    { threshold: 0 }
  );

  // Listen for scroll events to update position relative to buy buttons
  window.addEventListener("scroll", updateScrollPosition, { passive: true });

  // Listen for resize events to handle desktop/mobile transitions
  window.addEventListener("resize", updateStickyBarVisibility, { passive: true });

  // Initial setup
  if (buyButtons) {
    buyButtonsObserver.observe(buyButtons);
    updateScrollPosition();
  }

  if (footer) {
    footerObserver.observe(footer);
  }
});
